module.exports = dateToIdFriendlyTimestamp

// 2017-08-26T01:55:46.171Z -> 2017-08-26T015546
function dateToIdFriendlyTimestamp (date) {
  return date.toISOString().replace(/(\d\d):(\d\d):(\d\d).*$/, '$1$2$3')
}
